// @tennis-matches/core/utils/password-validation
// Gemeinsame Mindestanforderungen für Passwort-Felder (Registrierung).

export const MIN_PASSWORD_LENGTH = 8;

/**
 * @param {string} password
 * @param {string} passwordConfirm
 * @returns {{
 *   minLength: boolean,
 *   match: boolean,
 *   mismatch: boolean,
 *   hasPasswordInput: boolean,
 *   hasConfirmInput: boolean,
 *   allRequirementsMet: boolean,
 * }}
 */
export function evaluateRegistrationPassword(password, passwordConfirm) {
  const pw = String(password ?? "");
  const pw2 = String(passwordConfirm ?? "");
  const hasPasswordInput = pw.length > 0;
  const hasConfirmInput = pw2.length > 0;
  const minLength = pw.length >= MIN_PASSWORD_LENGTH;
  const match = hasConfirmInput && pw === pw2;
  const mismatch = hasConfirmInput && pw !== pw2;
  const allRequirementsMet = minLength && match;
  return {
    minLength,
    match,
    mismatch,
    hasPasswordInput,
    hasConfirmInput,
    allRequirementsMet,
  };
}
